import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'requirementLabel',
    standalone: false,
    pure: false
})
export class RequirementLabelPipe implements PipeTransform {

  private readonly languageNames = {
    de: { de: 'Deutsch', en: 'German' },
    en: { de: 'Englisch', en: 'English' }
  };

  private readonly languageLevels = {
    Basic: { de: 'Grundkenntnisse', en: 'Basic' },
    Good: { de: 'Gut', en: 'Good' },
    Fluent: { de: 'Fließend', en: 'Fluent' }
  };

  private readonly labels = {
    industry: { de: 'Branche', en: 'Industry' },
    degree: { de: 'Abschluss', en: 'Degree' },
    experience: { de: 'Berufserfahrung', en: 'Work experience' },
    oneYear: { de: 'Ein Jahr', en: 'one year' },
    years: { de: 'Jahre', en: 'years' }
  };

  transform(requirement: any, language: 'de' | 'en' = 'de'): string {
    if (!requirement) return '';

    switch (requirement.Type) {
      case 'Skill':
        return this.joinAlternatives(requirement.Alternatives);
      case 'Industry':
        return `${this.labels.industry[language]}: ${this.joinAlternatives(requirement.Alternatives)}`;
      case 'Degree':
        return `${this.labels.degree[language]}: ${this.joinAlternatives(requirement.Alternatives)}`;
      case 'Language':
        return `${this.languageNames[requirement.Alternatives?.[0]]?.[language] || requirement.Alternatives?.[0] || ''} (${this.languageLevels[requirement.Level]?.[language] || requirement.Level || ''})`;
      case 'Experience':
        return requirement.Min === 1
          ? `${this.labels.experience[language]}: ${this.labels.oneYear[language]}`
          : `${this.labels.experience[language]}: ${requirement.Min} ${this.labels.years[language]}`;
      case 'Custom':
        return requirement.Alternatives?.[0] || '';
      default:
        return '';
    }
  }

  private joinAlternatives(alternatives: string[] | undefined): string {
    return (alternatives || []).join(' | ');
  }
}
